<template>
    <div class="page magic-bg dark:text-white">
        <navigation :key="navigationKey"/>
        <div class="bookmark">
            <div class="bookmark-container">
                <div class="bookmark-modal" id="group_list_adjustments">
                    <div class="flex flex-row items-center justify-between mb-2">
                        <p class="bookmark-modal-title text-gradient mr-auto">Сортировка</p>
                        <button class="rounded-button" title="Очистить сортировку" @click="ClearParams">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 hover:animate-spin" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Поиск</label>
                        <input class="input sm:ml-2" type="text" v-model="search_param">
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28">Программа</label>
                        <select class="input sm:ml-2" v-model="program_param">
                            <option value="">Все</option>
                            <option :title="`[${program.Abbreviation}] ${program.Title} ${program.HourNumber} ч.`" :value="program.ID" v-for="(program, index) in programs" :key="index"> {{`[${program.Abbreviation}] ${program.Title} ${program.HourNumber} ч.`.length > 60 ? `[${program.Abbreviation}] ${program.Title} ${program.HourNumber} ч.`.slice(0, 60) + '...' : `[${program.Abbreviation}] ${program.Title} ${program.HourNumber} ч.`}}</option>
                        </select>
                    </div>
                    <div class="form-group ml-2 mt-2">
                        <label class="w-28 break-words">Статус</label>
                        <select class="input sm:ml-2" v-model="status_param">
                            <option value="">Все</option>
                            <option value="false">Открыта</option>
                            <option value="true">Закрыта</option>
                        </select>
                    </div>
                    <p class="bookmark-modal-title text-gradient mr-auto">Инструменты</p>
                    <button class="mt-2 ml-2 mr-auto" @click="pageNumber = 0;_ProccessGroups()">Запросить данные заново</button>
                    <button v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="mt-2 ml-2 mr-auto" @click="$root.ShowModal('#NewGroup')">Создать новую группу</button>
                </div>
            </div>
            <div class="bookmark-navbar">
                <div class="bookmark-link" @click="$root.ToggleBookmark('#group_list_adjustments')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" />
                    </svg>
                </div>
            </div>
        </div>

        <div class="flex flex-row items-end justify-between mt-4 w-[90%] max-w-[2000px] mx-auto fade">
            <div class="flex flex-row items-center justify-center background rounded-t-lg ml-3 py-2 px-3 fade">
                <p>С</p>
                <p class="ml-2">{{pageNumber * elementNumber + 1}}</p>
                <p class="ml-2">по</p>
                <p class="ml-2">{{pageNumber * elementNumber + groups.length}}</p>
                <p class="ml-2"><b class="text-gradient">Всего:</b> {{groupCount}}</p>
            </div>
            <div class="flex flex-row items-center justify-center background rounded-t-lg mr-3 py-2 px-3 fade">
                <button @click="Back">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
                <p>{{pageNumber + 1}}</p>
                <p class="ml-2">из</p>
                <p class="ml-2">{{pagesCount}}</p>
                <button @click="Forward">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>
        <div class="card py-0 w-[90%] max-w-[2000px] mx-auto overflow-auto fade" style="max-height: calc(100vh - 10rem)">
            <table class="sys-table mb-2">
                <thead>
                    <th>№</th>
                    <th v-if="$root.HasRole($store.state.adminRole)">ID</th>
                    <th>Программа</th>
                    <th>Название</th>
                    <th>Место проведения</th>
                    <th>Дата начала</th>
                    <th>Дата окончания</th>
                    <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)">Тип финансирования</th>
                    <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)">Цена</th>
                    <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)">Приказ о зачислении</th>
                    <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)">Приказ о выпуске</th>
                    <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)">Отчисленные</th>
                    <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)">Аттестация</th>
                    <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)">Пед. нагрузка</th>
                    <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)">Договоры</th>
                    <th>Статус</th>
                    <th></th>
                    <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)"></th>
                    <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)"></th>
                </thead>
                <tbody>
                    <tr v-for="(group, index) in groups" :key="index">
                        <th>{{pageNumber * elementNumber + index + 1}}</th>
                        <td v-if="$root.HasRole($store.state.adminRole)">{{group.ID}}</td>
                        <td>{{ProgramByID(group.ProgramID) !== null ? `[${ProgramByID(group.ProgramID).Abbreviation}] ${ProgramByID(group.ProgramID).Title} ${ProgramByID(group.ProgramID).HourNumber}` : '-'}}</td>
                        <td>{{group.Title}}</td>
                        <td>{{group.Location}}</td>
                        <td>{{group.BeginDate}}</td>
                        <td>{{group.EndDate}}</td>
                        <td v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)">{{group.FinancingType}}</td>
                        <td v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)">{{group.Price}}</td>
                        <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="cursor-pointer select-none" @click="SetCurrentGroup(index, '#SeeEnrollment')">просмотр</th>
                        <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="cursor-pointer select-none" @click="SetCurrentGroup(index, '#SeeDeduction')">просмотр</th>
                        <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="cursor-pointer select-none" @click="SetCurrentGroup(index, '#SeeDeducted')">{{group.Deducted.length}}</th>
                        <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="cursor-pointer select-none" @click="SetCurrentGroup(index, '#SeeCertification')">просмотр</th>
                        <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="cursor-pointer select-none" :class="ProgramByID(group.ProgramID) != null && group.PedagogicalLoad.TotalHourNumber < ProgramByID(group.ProgramID).HourNumber ? 'text-amber-600' : ''" @click="SetCurrentGroup(index, '#SeePedLoad')">просмотр</th>
                        <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="cursor-pointer select-none" @click="SetCurrentGroup(index, '#SeeContracts')">просмотр</th>
                        <td class="text-center">
                            <p :class="group.IsClosed ? 'text-red-600' : 'text-green-600'">{{group.IsClosed ? 'Закрыта' : 'Открыта'}}</p>
                            <p class="text-info" v-if="group.IsCombined">Объед.</p>
                        </td>
                        <th>
                            <button class="text-blue-600" @click="SeeGroup(group.ID)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </button>
                        </th>
                        <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)">
                            <button class="text-blue-600" @click="SetCurrentGroup(index,'#ChangeGroup')">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                </svg>
                            </button>
                        </th>
                        <th v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" @click="DeleteGroup(group.ID)">
                            <button class="text-red-600">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="NewGroup" @click="$root.HideModal('#NewGroup')">
        <form class="modal-dialog !max-w-6xl" @submit="NewGroup" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Новая группа</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#NewGroup')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <p class="title-sm sticky -top-4 bg-inherit z-[4003]">Основные данные</p>
                <div class="form-group w-full my-2">
                    <label class="input-label">Объединённая</label>
                    <input type="checkbox" class="checkbox-toggle sm:ml-auto" ref="group_combined">
                </div>
                <div class="flex flex-col w-full my-2">
                    <label class="input-label">Объединённые учебные группы</label>
                    <textarea class="input w-full max-w-full md:w-[50%] md:max-w-md md:ml-3" ref="group_combined_groups"></textarea>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Название <b class="text-red-600">*</b></label>
                    <input type="text" class="input sm:ml-auto" ref="group_title">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Программа <b class="text-red-600">*</b></label>
                    <select class="input sm:ml-auto" ref="group_program">
                        <option value="">Не выбрано</option>
                        <option :title="`[${program.Abbreviation}] ${program.Title} ${program.HourNumber} ч.`" :value="program.ID" v-for="(program, index) in programs" :key="index"> {{`[${program.Abbreviation}] ${program.Title} ${program.HourNumber} ч.`.length > 60 ? `[${program.Abbreviation}] ${program.Title} ${program.HourNumber} ч.`.slice(0, 60) + '...' : `[${program.Abbreviation}] ${program.Title} ${program.HourNumber} ч.`}}</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Место проведения</label>
                    <input type="text" class="input sm:ml-auto" ref="group_location">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дата начала <b class="text-red-600">*</b></label>
                    <input type="date" class="input sm:ml-auto" ref="group_begin_date">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дата окончания <b class="text-red-600">*</b></label>
                    <input type="date" class="input sm:ml-auto" ref="group_end_date">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Тип финансирования <b class="text-red-600">*</b></label>
                    <select class="input sm:ml-auto" ref="group_financing_type">
                        <option value="">Не выбрано</option>
                        <option :value="item.value" v-for="(item, index) in financing_type_items" :key="index">{{item.key}}</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Цена</label>
                    <input type="number" min="0" step="0.01" class="input sm:ml-auto" ref="group_price">
                </div>
                <p class="title-sm sticky -top-4 bg-inherit z-[4004] pt-3">Приказ о зачислении</p>
                <div class="flex flex-col">
                    <div class="form-group w-full my-2">
                        <label class="input-label">Номер</label>
                        <input type="text" class="input sm:ml-auto" ref="group_enrollment_number">
                    </div>
                    <div class="form-group w-full my-2">
                        <label class="input-label">Дата</label>
                        <input type="date" class="input sm:ml-auto" ref="group_enrollment_date">
                    </div>
                    <div class="row">
                        <div class="col-12 lg:col-6">
                            <p class="input-label">Все пользователи</p>
                            <div class="flex flex-row items-center justify-start my-3">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
                                </svg>
                                <input type="text" class="input ml-2" @input="FilterUsers">
                            </div>
                            <div class="list-container max-h-80 overflow-auto">
                                <div v-for="(user, key) in filtered_users" :key="key">
                                    <div class="list-container-item" v-if="!selected_users.includes(user.ID)">
                                        <p>{{user.FIO}}{{user.Role === 'listener' ? "(Слушатель)" : user.Role === 'worker' ? "(Работник)" : user.Role === 'student' ? "(Студент)" : ""}}</p>
                                        <button class="text-blue-600" @click="SelectUser(user.ID)">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6">
                            <p class="input-label">Участники группы</p>
                            <div class="list-container max-h-80 overflow-auto">
                                <div v-for="(user, index) in selected_users" :key="index">
                                    <div class="list-container-item">
                                        <p>{{UserByID(user).FIO}}{{UserByID(user).Role === 'listener' ? "(Слушатель)" : UserByID(user).Role === 'worker' ? "(Работник)" : UserByID(user).Role === 'student' ? "(Студент)" : ""}}</p>
                                        <button class="text-red-600" @click="RemoveUser(index)">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="title-sm mt-3 sticky -top-4 bg-inherit z-[4005] pt-3">Приказ о пед. нагрузке</p>
                <div class="form-group w-full my-2">
                    <label class="input-label">Номер</label>
                    <input type="text" class="input sm:ml-auto" ref="pedagogical_load_number">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дата</label>
                    <input type="date" class="input sm:ml-auto" ref="pedagogical_load_date">
                </div>
                <label class="input-label">Пед. нагрузка</label>
                <table class="sys-table mb-2 mt-5">
                    <thead>
                        <th>№</th>
                        <th>Сотрудник</th>
                        <th>Дисциплина</th>
                        <th>Кол-во часов</th>
                        <th>
                            <button type="button" class="rounded-button mx-auto" @click="$root.HideModal('#NewGroup');$root.ShowModal('#NewLoad')">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="(load, index) in pedLoad" :key="index">
                            <th>{{index + 1}}</th>
                            <td class="text-center">{{UserByID(load.Worker).FIO}}</td>
                            <td class="text-center">{{load.Discipline}}</td>
                            <td class="text-center">{{load.HourNumber}}</td>
                            <th>
                                <button class="text-red-600" @click="RemoveLoad(index)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#NewGroup')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#NewGroup')">Добавить</button>
            </div>
        </form>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="NewLoad" @click="$root.HideModal('#NewLoad');$root.ShowModal('#NewGroup')">
        <form class="modal-dialog" @submit="NewLoad" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Новая пед. нагрузка</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#NewLoad');$root.ShowModal('#NewGroup')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Сотрудник</label>
                    <select class="input sm:ml-auto" ref="load_worker">
                        <option :value="worker.ID" v-for="(worker, index) in workers" :key="index">{{worker.FIO}}</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дисциплина</label>
                    <input type="text" class="input sm:ml-auto" ref="load_discipline">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Кол-во часов</label>
                    <input type="number" min="0" class="input sm:ml-auto" ref="load_hour_number">
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="reset" class="modal-dialog-footer-button" @click="$root.HideModal('#NewLoad');$root.ShowModal('#NewGroup')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#NewLoad');$root.ShowModal('#NewGroup')">Добавить</button>
            </div>
        </form>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="ChangeGroup" @click="$root.HideModal('#ChangeGroup')">
        <form class="modal-dialog" @submit="ChangeGroup" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение данных группы</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeGroup')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Статус</label>
                    <select class="input sm:ml-auto" ref="current_group_status" :value="currentGroup.IsClosed">
                        <option value="false">Открыта</option>
                        <option value="true">Закрыта</option>
                    </select>
                </div>
                <div class="form-group w-full my-2" v-if="!currentGroup.IsClosed">
                    <label class="input-label">Объединённая</label>
                    <input type="checkbox" class="checkbox-toggle sm:ml-auto" ref="current_group_combined" :checked="currentGroup.IsCombined">
                </div>
                <div class="form-group w-full my-2" v-if="!currentGroup.IsClosed">
                    <label class="input-label">Название</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_title" :value="currentGroup.Title">
                </div>
                <div class="form-group w-full my-2" v-if="!currentGroup.IsClosed">
                    <label class="input-label">Место проведения</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_location" :value="currentGroup.Location">
                </div>
                <div class="form-group w-full my-2" v-if="!currentGroup.IsClosed">
                    <label class="input-label">Дата начала</label>
                    <input type="date" class="input sm:ml-auto" ref="current_group_begin_date" :value="$root.FormatInputDate(currentGroup.BeginDate)">
                </div>
                <div class="form-group w-full my-2" v-if="!currentGroup.IsClosed">
                    <label class="input-label">Дата окончания</label>
                    <input type="date" class="input sm:ml-auto" ref="current_group_end_date" :value="$root.FormatInputDate(currentGroup.EndDate)">
                </div>
                <div class="form-group w-full my-2" v-if="!currentGroup.IsClosed">
                    <label class="input-label">Тип финансирования</label>
                    <select class="input sm:ml-auto" ref="current_group_financing_type" :value="currentGroup.FinancingType">
                        <option value="">Не выбрано</option>
                        <option :value="item.value" v-for="(item, index) in financing_type_items" :key="index">{{item.key}}</option>
                    </select>
                </div>
                <div class="form-group w-full my-2" v-if="!currentGroup.IsClosed">
                    <label class="input-label">Цена</label>
                    <input type="number" min="0" step="0.01" class="input sm:ml-auto" ref="current_group_price" :value="currentGroup.Price">
                </div>
                <div class="flex flex-col w-full my-2" v-if="!currentGroup.IsClosed">
                    <label class="input-label">Объединённые учебные группы</label>
                    <textarea class="input w-full max-w-full md:w-[50%] md:max-w-md md:ml-3" :value="currentGroup.CombinedGroups" ref="current_group_combined_groups"></textarea>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeGroup')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeGroup')">Изменить</button>
            </div>
        </form>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="SeeEnrollment" @click="$root.HideModal('#SeeEnrollment')">
        <div class="modal-dialog" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Просмотр приказа о зачислении</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#SeeEnrollment')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <p class="subtitle">Номер</p>
                    <p>{{currentGroup.Enrollment.Number}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <p class="subtitle">Дата</p>
                    <p>{{currentGroup.Enrollment.Date}}</p>
                </div>
                <div class="flex flex-col">
                    <p class="subtitle">Список пользователей({{currentGroup.Enrollment.Listeners.length + currentGroup.Enrollment.Workers.length + currentGroup.Enrollment.Students.length}})</p>
                    <div class="flex flex-row items-center justify-between mb-2" v-for="(student, student_index) in currentGroup.Enrollment.Students" :key="student_index">
                        <p class="ml-3"><b>{{student_index + 1}}.</b> {{UserByID(student) !== null ? UserByID(student).FIO : 'данных нет'}}</p>
                        <div class="badge ml-2">Студент</div>
                    </div>
                    <div class="flex flex-row items-center justify-between mb-2" v-for="(listener, listener_index) in currentGroup.Enrollment.Listeners" :key="listener_index">
                        <p class="ml-3"><b>{{listener_index + 1}}.</b> {{UserByID(listener) !== null ? UserByID(listener).FIO : 'данных нет'}}</p>
                        <div class="badge info ml-2">Слушатель</div>
                    </div>
                    <div class="flex flex-row items-center justify-between mb-2"  v-for="(worker, worker_index) in currentGroup.Enrollment.Workers" :key="worker_index">
                        <p class="ml-3"><b>{{worker_index + 1}}.</b> {{UserByID(worker) !== null ? UserByID(worker).FIO : 'данных нет'}}</p>
                        <div class="badge warning ml-2">Работник</div>
                    </div>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button v-if="!currentGroup.IsClosed" type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#SeeEnrollment');$root.ShowModal('#ChangeEnrollmentUsers')">Редактировать список пользователей</button>
                <button v-if="!currentGroup.IsClosed" type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#SeeEnrollment');$root.ShowModal('#ChangeEnrollment')">Изменить</button>
            </div>
        </div>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="ChangeEnrollmentUsers" @click="$root.HideModal('#ChangeEnrollmentUsers');$root.ShowModal('#SeeEnrollment')">
        <div class="modal-dialog !max-w-6xl" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Редактирование участников группы</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeEnrollmentUsers');$root.ShowModal('#SeeEnrollment')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="flex flex-col">
                    <div class="row">
                        <div class="col-12 lg:col-6">
                            <p class="input-label">Все пользователи</p>
                            <div class="flex flex-row items-center justify-start my-3">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
                                </svg>
                                <input type="text" class="input ml-2" @input="FilterUsers">
                            </div>
                            <div class="list-container max-h-80 overflow-auto">
                                <div v-for="(user, key) in filtered_users" :key="key">
                                    <div class="list-container-item" v-if="!currentGroupUsers.includes(user.ID)">
                                        <p>{{user.FIO}}{{user.Role === 'listener' ? "(Слушатель)" : user.Role === 'worker' ? "(Работник)" : user.Role === 'student' ? "(Студент)" : ""}}</p>
                                        <button class="text-blue-600" @click="SelectCurrentGroupUser(user.ID)">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6">
                            <p class="input-label">Участники группы</p>
                            <div class="list-container max-h-80 overflow-auto">
                                <div v-for="(user, index) in currentGroupUsers" :key="index">
                                    <div class="list-container-item">
                                        <p><b>{{index + 1}}.</b> {{UserByID(user).FIO}}{{currentGroup.Enrollment.Listeners.includes(user) ? "(Слушатель)" : currentGroup.Enrollment.Workers.includes(user) ? "(Работник)" : currentGroup.Enrollment.Students.includes(user) ? "(Студент)" : ""}}</p>
                                        <button class="text-red-600" @click="RemoveCurrentGroupUser(index)">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="ChangeEnrollment" @click="$root.HideModal('#ChangeEnrollment');$root.ShowModal('#SeeEnrollment')">
        <form class="modal-dialog" @submit="ChangeEnrollment" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение данных группы</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeEnrollment');$root.ShowModal('#SeeEnrollment')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Номер</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_enrollment_number" :value="currentGroup.Enrollment.Number">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дата</label>
                    <input type="date" class="input sm:ml-auto" ref="current_group_enrollment_date" :value="$root.FormatInputDate(currentGroup.Enrollment.Date)">
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeEnrollment');$root.ShowModal('#SeeEnrollment')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeEnrollment');$root.ShowModal('#SeeEnrollment')">Изменить</button>
            </div>
        </form>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="SeeDeduction" @click="$root.HideModal('#SeeDeduction')">
        <div class="modal-dialog" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Просмотр приказа о выпуске</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#SeeDeduction')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <p class="subtitle">Номер</p>
                    <p>{{currentGroup.Deduction.Number}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <p class="subtitle">Дата</p>
                    <p>{{currentGroup.Deduction.Date}}</p>
                </div>
                <div class="flex flex-col">
                    <p class="subtitle">Список пользователей({{currentGroup.Deduction.Listeners.length + currentGroup.Deduction.Workers.length + currentGroup.Deduction.Students.length}})</p>
                    <div class="flex flex-row items-center justify-between mb-2" v-for="(student, student_index) in currentGroup.Deduction.Students" :key="student_index">
                        <p class="ml-3"><b>{{student_index + 1}}.</b> {{UserByID(student) !== null ? UserByID(student).FIO : 'данных нет'}}</p>
                        <div class="badge ml-2">Студент</div>
                    </div>
                    <div class="flex flex-row items-center justify-between mb-2" v-for="(listener, listener_index) in currentGroup.Deduction.Listeners" :key="listener_index">
                        <p class="ml-3"><b>{{listener_index + 1}}.</b> {{UserByID(listener) !== null ? UserByID(listener).FIO : 'данных нет'}}</p>
                        <div class="badge info ml-2">Слушатель</div>
                    </div>
                    <div class="flex flex-row items-center justify-between mb-2"  v-for="(worker, worker_index) in currentGroup.Deduction.Workers" :key="worker_index">
                        <p class="ml-3"><b>{{worker_index + 1}}.</b> {{UserByID(worker) !== null ? UserByID(worker).FIO : 'данных нет'}}</p>
                        <div class="badge warning ml-2">Работник</div>
                    </div>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button v-if="!currentGroup.IsClosed" type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#SeeDeduction');$root.ShowModal('#ChangeDeduction')">Изменить</button>
            </div>
        </div>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="ChangeDeduction" @click="$root.HideModal('#ChangeDeduction');$root.ShowModal('#SeeDeduction')">
        <form class="modal-dialog" @submit="ChangeDeduction" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение данных группы</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeDeduction');$root.ShowModal('#SeeDeduction')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Номер</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_deduction_number" :value="currentGroup.Deduction.Number">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дата</label>
                    <input type="date" class="input sm:ml-auto" ref="current_group_deduction_date" :value="$root.FormatInputDate(currentGroup.Deduction.Date)">
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeDeduction');$root.ShowModal('#SeeDeduction')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeDeduction');$root.ShowModal('#SeeDeduction')">Изменить</button>
            </div>
        </form>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="SeeDeducted" @click="$root.HideModal('#SeeDeducted')">
        <div class="modal-dialog !max-w-6xl" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Редактирование отчисленных пользователей</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#SeeDeducted')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <table class="sys-table mb-2">
                    <thead class="!-top-4 z-[4002]">
                        <th>№</th>
                        <th v-if="$root.HasRole($store.state.adminRole)">ID</th>
                        <th>Номер приказа</th>
                        <th>Дата приказа</th>
                        <th>Пользователь</th>
                        <th>
                            <button v-if="!currentGroup.IsClosed" class="rounded-button mx-auto" @click="$root.HideModal('#SeeDeducted');$root.ShowModal('#NewDeducted')">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                        <th></th>
                    </thead>
                    <tbody>
                        <tr v-for="(order, index) in currentGroup.Deducted" :key="index">
                            <th>{{index + 1}}</th>
                            <th v-if="$root.HasRole($store.state.adminRole)">{{order.ID}}</th>
                            <td class="text-center">{{order.Number}}</td>
                            <td class="text-center">{{order.Date}}</td>
                            <td class="text-center">{{UserByID(order.UserID) != null ? UserByID(order.UserID).FIO : 'данных нет'}}</td>
                            <th>
                                <button v-if="!currentGroup.IsClosed" class="text-blue-600" @click="$root.HideModal('#SeeDeducted');SetCurrentDeducted(index, '#ChangeDeducted')">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                    </svg>
                                </button>
                            </th>
                            <th>
                                <button v-if="!currentGroup.IsClosed" class="text-red-600" @click="DeleteDeducted(index)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="NewDeducted" @click="$root.HideModal('#NewDeducted');$root.ShowModal('#SeeDeducted')">
        <form class="modal-dialog" @submit="NewDeducted" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Новый приказ об отчислении</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#NewDeducted');$root.ShowModal('#SeeDeducted')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Номер приказа</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_deducted_number">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дата приказа</label>
                    <input type="date" class="input sm:ml-auto" ref="current_group_deducted_date">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Участник группы</label>
                    <select class="input sm:ml-auto" ref="current_group_deducted_user">
                        <option :value="user" v-for="(user, index) in currentGroupUsers" :key="index">{{UserByID(user).FIO}}{{currentGroup.Enrollment.Listeners.includes(user) ? "(Слушатель)" : currentGroup.Enrollment.Workers.includes(user) ? "(Работник)" : currentGroup.Enrollment.Students.includes(user) ? "(Студент)" : ""}}</option>
                    </select>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="reset" class="modal-dialog-footer-button" @click="$root.HideModal('#NewDeducted');$root.ShowModal('#SeeDeducted')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#NewDeducted');$root.ShowModal('#SeeDeducted')">Добавить</button>
            </div>
        </form>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="ChangeDeducted" @click="$root.HideModal('#ChangeDeducted');$root.ShowModal('#SeeDeducted')">
        <form class="modal-dialog" @submit="ChangeDeducted" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение приказа об отчислении</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeDeducted');$root.ShowModal('#SeeDeducted')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Номер приказа</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_current_deducted_number" :value="currentDeducted.Number">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дата приказа</label>
                    <input type="date" class="input sm:ml-auto" ref="current_group_current_deducted_date" :value="$root.FormatInputDate(currentDeducted.Date)">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Участник группы</label>
                    <select class="input sm:ml-auto" ref="current_group_current_deducted_user" :value="currentDeducted.UserID">
                        <option :value="user" v-for="(user, index) in currentGroupUsers" :key="index">{{UserByID(user).FIO}}{{currentGroup.Enrollment.Listeners.includes(user) ? "(Слушатель)" : currentGroup.Enrollment.Workers.includes(user) ? "(Работник)" : currentGroup.Enrollment.Students.includes(user) ? "(Студент)" : ""}}</option>
                    </select>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeDeducted');$root.ShowModal('#SeeDeducted')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeDeducted');$root.ShowModal('#SeeDeducted')">Добавить</button>
            </div>
        </form>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="SeeCertification" @click="$root.HideModal('#SeeCertification')">
        <div class="modal-dialog" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Просмотр аттестации</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#SeeCertification')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <p class="subtitle">Номер</p>
                    <p>{{currentGroup.Certification.Number}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <p class="subtitle">Дата</p>
                    <p>{{currentGroup.Certification.Date}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <p class="subtitle">Тип работы</p>
                    <p>{{currentGroup.Certification.FinalWorkType}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <p class="subtitle">Форма аттестации</p>
                    <p>{{currentGroup.Certification.FinalCertificationForm}}</p>
                </div>
                <div class="flex flex-col">
                    <p class="subtitle">Члены аттестационной комиссии</p>
                    <div class="flex flex-row items-center justify-between mb-2">
                        <p class="ml-3">{{currentGroup.Certification.ComissionChairman.FIO}} {{currentGroup.Certification.ComissionChairman.Post.trim() !== "" ? `- ${currentGroup.Certification.ComissionChairman.Post}` : ''}}</p>
                        <div class="badge info ml-2">Председатель</div>
                    </div>
                    <div class="flex flex-row items-center justify-between mb-2"  v-for="(member, member_index) in currentGroup.Certification.Members" :key="member_index">
                        <p class="ml-3">{{member.FIO}} {{member.Post.trim() !== "" ? `- ${member.Post}` : ''}}</p>
                    </div>
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button v-if="!currentGroup.IsClosed" type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#SeeCertification');$root.ShowModal('#ChangeCertificationMembers')">Редактировать членов аттестационной комиссии</button>
                <button v-if="!currentGroup.IsClosed" type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#SeeCertification');$root.ShowModal('#ChangeCertification')">Изменить</button>
            </div>
        </div>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="ChangeCertification" @click="$root.HideModal('#ChangeCertification');$root.ShowModal('#SeeCertification')">
        <form class="modal-dialog" @submit="ChangeCertification" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение данных аттестации</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeCertification');$root.ShowModal('#SeeCertification')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Номер</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_number" :value="currentGroup.Certification.Number">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дата</label>
                    <input type="date" class="input sm:ml-auto" ref="current_group_certification_date" :value="$root.FormatInputDate(currentGroup.Certification.Date)">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Тип работы</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_work_type" :value="currentGroup.Certification.FinalWorkType">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Форма аттестации</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_certification_type" :value="currentGroup.Certification.FinalCertificationForm">
                </div>
                <p class="title-sm">Председатель аттестационной комиссии</p>
                <div class="form-group w-full my-2">
                    <label class="input-label">Фамилия</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_chairman_surname" :value="currentGroup.Certification.ComissionChairman.Surname">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Имя</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_chairman_name" :value="currentGroup.Certification.ComissionChairman.Name">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Отчество</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_chairman_lastname" :value="currentGroup.Certification.ComissionChairman.Lastname">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Должность</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_chairman_post" :value="currentGroup.Certification.ComissionChairman.Post">
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeCertification');$root.ShowModal('#SeeCertification')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeCertification');$root.ShowModal('#SeeCertification')">Изменить</button>
            </div>
        </form>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="ChangeCertificationMembers" @click="$root.HideModal('#ChangeCertificationMembers');$root.ShowModal('#SeeCertification')">
        <div class="modal-dialog !max-w-3xl" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Редактирование членов аттестационной комиссии</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeCertificationMembers');$root.ShowModal('#SeeCertification')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <table class="sys-table mb-2">
                    <thead class="!-top-4 z-[4002]">
                        <th>№</th>
                        <th>ФИО</th>
                        <th>Должность</th>
                        <th>
                            <button class="rounded-button mx-auto" @click="$root.HideModal('#ChangeCertificationMembers');$root.ShowModal('#ChangeMember')">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                        <th></th>
                    </thead>
                    <tbody>
                        <tr v-for="(member, index) in currentGroup.Certification.Members" :key="index">
                            <th>{{index + 1}}</th>
                            <td class="text-center">{{member.FIO}}</td>
                            <td class="text-center">{{member.Post}}</td>
                            <th>
                                <button class="text-blue-600" @click="$root.HideModal('#ChangeCertificationMembers');SetCurrentMember(index, '#ChangeMember')">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                    </svg>
                                </button>
                            </th>
                            <th>
                                <button class="text-red-600"  @click="DeleteCertificationMember(index)">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="AddCertificationMember" @click="$root.HideModal('#AddCertificationMember');$root.ShowModal('#ChangeCertificationMembers')">
        <form class="modal-dialog" @submit="AddCertificationMember" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Новый член аттестационной комиссии</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#AddCertificationMember');$root.ShowModal('#ChangeCertificationMembers')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Фамилия</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_member_surname">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Имя</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_member_name">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Отчество</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_member_lastname">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Должность</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_member_post">
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="reset" class="modal-dialog-footer-button" @click="$root.HideModal('#AddCertificationMember');$root.ShowModal('#ChangeCertificationMembers')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#AddCertificationMember');$root.ShowModal('#ChangeCertificationMembers')">Добавить</button>
            </div>
        </form>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="ChangeMember" @click="$root.HideModal('#ChangeMember');$root.ShowModal('#ChangeCertificationMembers')">
        <form class="modal-dialog" @submit="ChangeMember" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Новый член аттестационной комиссии</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeMember');$root.ShowModal('#ChangeCertificationMembers')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Фамилия</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_current_member_surname" :value="currentMember.Surname">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Имя</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_current_member_name" :value="currentMember.Name">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Отчество</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_current_member_lastname" :value="currentMember.Lastname">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Должность</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_certification_current_member_post" :value="currentMember.Post">
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeMember');$root.ShowModal('#ChangeCertificationMembers')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeMember');$root.ShowModal('#ChangeCertificationMembers')">Изменить</button>
            </div>
        </form>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="SeePedLoad" @click="$root.HideModal('#SeePedLoad')">
        <div class="modal-dialog !max-w-3xl" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Просмотр пед. нагрузки</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#SeePedLoad')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="badge warning mr-auto mb-2" v-if="ProgramByID(currentGroup.ProgramID) != null && currentGroup.PedagogicalLoad.TotalHourNumber < ProgramByID(currentGroup.ProgramID).HourNumber">
                    Общее кол-во часов в пед. нагрузке не соответствует выбраной программе
                </div>
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <p class="subtitle">Номер</p>
                    <p>{{currentGroup.PedagogicalLoad.Number}}</p>
                </div>
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                    <p class="subtitle">Дата</p>
                    <p>{{currentGroup.PedagogicalLoad.Date}}</p>
                </div>
                <table class="sys-table mb-2">
                    <thead class="!-top-4 z-[4002]">
                        <th>№</th>
                        <th>Работник</th>
                        <th>Дисциплина</th>
                        <th>Кол-во часов</th>
                        <th v-if="!currentGroup.IsClosed">
                            <button class="rounded-button mx-auto" @click="$root.HideModal('#SeePedLoad');$root.ShowModal('#NewCurrentGroupLoad')">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </th>
                        <th v-if="!currentGroup.IsClosed"></th>
                    </thead>
                    <tbody>
                        <tr v-for="(load, index) in currentGroup.PedagogicalLoad.Loads" :key="index">
                            <th>{{index + 1}}</th>
                            <td class="text-center">{{UserByID(load.WorkerID) !== null ? UserByID(load.WorkerID).FIO : 'данных нет'}}</td>
                            <td class="text-center">{{load.Discipline}}</td>
                            <td class="text-center">{{load.HourNumber}}</td>
                            <th v-if="!currentGroup.IsClosed">
                                <button class="text-blue-600" @click="$root.HideModal('#SeePedLoad');SetCurrentLoad(index, '#ChangeCurrentGroupLoad')">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                    </svg>
                                </button>
                            </th>
                            <th v-if="!currentGroup.IsClosed" @click="DeleteCurrentGroupLoad(index)">
                                <button class="text-red-600">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                    </svg>
                                </button>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-dialog-footer">
                <button v-if="!currentGroup.IsClosed" type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#SeePedLoad');$root.ShowModal('#ChangePedLoad')">Изменить</button>
            </div>
        </div>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="ChangePedLoad" @click="$root.HideModal('#ChangePedLoad');$root.ShowModal('#SeePedLoad')">
        <form class="modal-dialog" @submit="ChangePedLoad" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Изменение приказа о пед. нагрузки</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangePedLoad');$root.ShowModal('#SeePedLoad')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Номер</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_ped_load_number" :value="currentGroup.PedagogicalLoad.Number">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дата</label>
                    <input type="date" class="input sm:ml-auto" ref="current_group_ped_load_date" :value="$root.FormatInputDate(currentGroup.PedagogicalLoad.Date)">
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangePedLoad');$root.ShowModal('#SeePedLoad')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangePedLoad');$root.ShowModal('#SeePedLoad')">Изменить</button>
            </div>
        </form>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="NewCurrentGroupLoad" @click="$root.HideModal('#NewCurrentGroupLoad');$root.ShowModal('#SeePedLoad')">
        <form class="modal-dialog" @submit="NewCurrentGroupLoad" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Новая пед. нагрузка</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#NewCurrentGroupLoad');$root.ShowModal('#SeePedLoad')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Сотрудник</label>
                    <select class="input sm:ml-auto" ref="current_group_load_worker">
                        <option :value="worker.ID" v-for="(worker, index) in workers" :key="index">{{worker.FIO}}</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дисциплина</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_load_discipline">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Кол-во часов</label>
                    <input type="number" min="0" class="input sm:ml-auto" ref="current_group_load_hour_number">
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="reset" class="modal-dialog-footer-button" @click="$root.HideModal('#NewCurrentGroupLoad');$root.ShowModal('#SeePedLoad')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#NewCurrentGroupLoad');$root.ShowModal('#SeePedLoad')">Добавить</button>
            </div>
        </form>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="ChangeCurrentGroupLoad" @click="$root.HideModal('#ChangeCurrentGroupLoad');$root.ShowModal('#SeePedLoad')">
        <form class="modal-dialog" @submit="ChangeCurrentGroupLoad" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Новая пед. нагрузка</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeCurrentGroupLoad');$root.ShowModal('#SeePedLoad')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body">
                <div class="form-group w-full my-2">
                    <label class="input-label">Сотрудник</label>
                    <select class="input sm:ml-auto" ref="current_group_current_load_worker" :value="currentLoad.WorkerID">
                        <option :value="worker.ID" v-for="(worker, index) in workers" :key="index">{{worker.FIO}}</option>
                    </select>
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Дисциплина</label>
                    <input type="text" class="input sm:ml-auto" ref="current_group_current_load_discipline" :value="currentLoad.Discipline">
                </div>
                <div class="form-group w-full my-2">
                    <label class="input-label">Кол-во часов</label>
                    <input type="number" min="0" class="input sm:ml-auto" ref="current_group_current_load_hour_number" :value="currentLoad.HourNumber">
                </div>
            </div>
            <div class="modal-dialog-footer">
                <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeCurrentGroupLoad');$root.ShowModal('#SeePedLoad')">Закрыть</button>
                <button type="submit" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeCurrentGroupLoad');$root.ShowModal('#SeePedLoad')">Изменить</button>
            </div>
        </form>
    </div>

    <div v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)" class="modal dark:text-white" id="SeeContracts" @click="$root.HideModal('#SeeContracts')">
        <div class="modal-dialog" @click="(e)=>{e.stopPropagation()}">
            <div class="modal-dialog-header">
                <p class="modal-dialog-title">Просмотр договоров</p>
                <button type="button" class="ml-auto" @click="$root.HideModal('#SeeContracts')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
            </div>
            <div class="modal-dialog-body min-h-[320px]">
                <Multiselect
                    v-model="download_contract_users"
                    class="sm:ml-auto mt-2"
                    ref="download_contract_users"
                    :options="CreateGroupUsersOptions(currentGroupUsers)"
                    mode="tags"
                    :canClear="false"
                    :searchable="true"
                    :close-on-select="false"
                    noResultsText="Ничего не найдено"
                    :classes="{
                        container: 'relative input flex items-center justify-end box-border cursor-pointer p-1 max-w-full',
                        dropdown: 'max-h-60 absolute left-1 right-1 bottom-0 transform translate-y-full -mt-px overflow-y-scroll z-50 background-darker flex flex-col rounded-b',
                        dropdownHidden: 'hidden',
                        optionPointed: 'bg-black/5 dark:bg-white/5',
                        tagsSearch: 'absolute inset-0 border-0 outline-none appearance-none p-0 text-base box-border bg-transparent w-full',
                        noResults: 'py-2 px-3 text-secondary text-left',
                    }"
                >
                    <template v-slot:tag="{ option, handleTagRemove, disabled }">
                        <div class="multiselect-tag is-user gradient dark:!bg-gradient-to-tl max-w-[150px] md:max-w-xs lg:max-w-none break-words whitespace-normal" :class="{'is-disabled': disabled}">
                            {{ option.label }}
                            <span v-if="!disabled" class="multiselect-tag-remove" @click="handleTagRemove(option, $event)">
                                <span class="multiselect-tag-remove-icon"></span>
                            </span>
                        </div>
                    </template>
                    <template v-slot:option="{ option }">
                        {{ option.label }}
                    </template>
                </Multiselect>
                <div class="flex flex-row items-center p-2">
                    <button class="mx-2 text-success" @click="$refs['download_contract_users'].selectAll()">Выбрать всё</button>
                    <button class="mx-2 text-danger" @click="$refs['download_contract_users'].clear()">Очистить</button>
                </div>
                <p class="text-lg font-bold mt-2">Скачать</p>
                <div class="group-widget-container">
                    <div class="group-widget-header" @click="$root.ToggleGroupWidget('dodop')" :class="!$root.IsGroupWidgetShown('dodop') ? 'rounded-b-lg' : ''">
                        <div class="group-widget-title mr-auto">Договор об образовании по дополнительным общеразвивающим программам</div>
                        <button class="group-widget-title-button">
                            <svg xmlns="http://www.w3.org/2000/svg" class="!cursor-pointer h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" v-if="$root.IsGroupWidgetShown('dodop')">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" class="!cursor-pointer h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" v-else>
                                <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                        </button>
                    </div>
                    <div class="group-widget-body" v-if="$root.IsGroupWidgetShown('dodop')">
                        <div class="flex flex-col ml-4">
                            <div class="form-group w-full my-2">
                                <label class="input-label">Дата договора <b class="text-red-600">*</b></label>
                                <input type="date" class="input sm:ml-auto" v-model="contract_buffer.dodop.date">
                            </div>
                            <div class="flex flex-row items-center justify-between my-3 mx-2">
                                <button class="ml-auto mr-2 text-info" @click="DownloadDodop">Скачать</button>
                                <button class="text-success" :disabled="!contract_buffer.dodop.can_be_confirmed" @click="ConfirmDodop">Подтвердить</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style src="@vueform/multiselect/themes/default.css"></style>

<script>
import Navigation from '@/components/Navigation'
import Multiselect from '@vueform/multiselect'

export default {
    components: {
        Navigation,
        Multiselect
    },
    data() {
        return {
            onlyMyGroups: false,
            users: {},
            workers: [],
            filtered_users: {},
            programs: [],
            groups: [],
            currentGroup: {
                ID: "",
                ProgramID: "",
                IsClosed: false,
                IsCombined: false,
                CombinedGroups: "",
                Title: "",
                Location: "",
                BeginDate: "",
                EndDate: "",
                Price: "",
                FinancingType: "",
                Enrollment: {
                    Number: "",
                    Date: "",
                    Listeners: [],
                    Workers: [],
                    Students: []
                },
                Deduction: {
                    Number: "",
                    Date: "",
                    Listeners: [],
                    Workers: [],
                    Students: [],
                    Document: ""
                },
                Deducted: [],
                PedagogicalLoad: {
                    Number: "",
                    Date: "",
                    TotalHourNumber: 0,
                    Loads: []
                },
                Certification: {
                    Number: "",
                    FinalWorkType: "",
                    FinalCertificationForm: "",
                    Date: "",
                    ComissionChairman: {
                        FIO: "",
                        Post: ""
                    },
                    Members: []
                }
            },
            currentMember: {
                FIO: "",
                Surname: "",
                Name: "",
                Lastname: "",
                Post: ""
            },
            currentLoad: {
                WorkerID: "",
                Discipline: "",
                HourNumber: 0,
            },
            currentDeducted: {
                ID: "",
                UserID: "",
                Number: "",
                Date: ""
            },
            currentGroupUsers: [],
            pedLoad: [],
            groupCount: 0,
            elementNumber: 25,
            pageNumber: 0,
            pagesCount: 0,
            search_param: "",
            program_param: "",
            status_param: "",
            financing_type_items: [],
            selected_users: [],
            download_contract_users: [],
            contract_buffer: {
                dodop: {
                    name: null,
                    date: null,
                    can_be_confirmed: false
                }
            },
            navigationKey: "nav",
            title: "Список учебных групп"
        }
    },
    methods: {
        SetTitle() {
            document.title = `Samgk DPO - ${this.title}`
        },
        Forward() {
            this.pageNumber = this.pageNumber >= this.pagesCount - 1 ? 0 : this.pageNumber + 1
            this._ProccessGroups()
        },
        Back() {
            this.pageNumber = this.pageNumber <= 0 ? this.pagesCount - 1 : this.pageNumber - 1
            this._ProccessGroups()
        },
        ClearParams() {
            this.search_param = ""
            this.program_param = ""
            this.status_param = ""
        },
        async _SelectData() {
            let res = await fetch(this.$store.state.aeApiAddr + "/v1.0/selects/type_of_financing", {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            this.financing_type_items = res.data.select.variants
        },
        async _ProccessPrograms() {

            let res = await fetch(this.$store.state.aeApiAddr + `/v1.0/programs/list`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            let programs = []
            for (var i in res.data.programs) {
                var program = res.data.programs[i]

                programs.push({
                    ID: program.id,
                    Title: program.title,
                    Abbreviation: program.abbreviation,
                    HourNumber: program.number_of_hours
                })
            }

            this.programs = programs
        },
        async _ProccessUsers() {
            let workers = []
            let users = []

            let currentPage = 0
            let chunkSize = 500

            while(true) {
                var res = await fetch(this.$store.state.apiAddr + `/v1.0/users/list?alphabetical=true&limit=${chunkSize}&skip=${currentPage * chunkSize}`, {
                    method: "GET",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                    },
                }).then(response => {return response.json()})
                .catch(error => {
                    this.$root.Fatal()
                })

                if (!res || !res.data || !res.data.users || res.data.users.length == 0) break

                for (var i in res.data.users) {
                
                    var user = res.data.users[i]

                    if (user.is_system) {
                        continue
                    }

                    var listener = user.listener

                    var worker = user.worker

                    var student = user.student

                    var role = user.roles.includes(this.$store.state.employeeRole) ? "worker" : user.roles.includes(this.$store.state.studentRole) ? "student" : user.roles.includes(this.$store.state.listenerRole) ? "listener" : null

                    if (role === "worker") {
                        workers.push({
                            ID: user.id,
                            FIO: `${worker.surname} ${worker.name} ${worker.middle_name}`
                        })
                    }

                    users.push({
                        ID: user.id,
                        FIO: role === "listener" ? `${listener.surname} ${listener.name} ${listener.middle_name}` : role === "worker" ? `${worker.surname} ${worker.name} ${worker.middle_name}` : role === "student" ? `${student.surname} ${student.name} ${student.middle_name}` : null,
                        Role: role
                    })
                }

                currentPage += 1
            }

            let usersDict = {}

            users.forEach((elem) => {
                usersDict[elem.ID] = elem
            })

            this.users = usersDict
            this.filtered_users = usersDict
            this.workers = workers
        },
        async _ProccessGroups() {
            this.$root.StartLoading()

            let res = await fetch(this.$store.state.aeApiAddr + `/v1.0/study_groups${this.$root.HasRole(this.$store.state.methodistRole) || this.$root.HasRole(this.$store.state.adminRole) ? '/' : '/me/'}list?limit=${this.elementNumber}&skip=${this.pageNumber * this.elementNumber}&search=${this.search_param}&program=${this.program_param}&is_closed=${this.status_param}&me=${this.onlyMyGroups}`, {
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                },
            }).then(response => {return response.json()})
            .catch(error => {
                this.$root.Fatal()
            })

            if (this.$root.HandleFetchError(res)) return

            this.groupCount = res.data.collections

            this.pagesCount = Math.ceil(this.groupCount / this.elementNumber)

            let groups = []
            for (var i in res.data.study_groups) {
                var group = res.data.study_groups[i]
                var enrollmentOrder = group.orders.order_of_enrollment
                var deductionOrder = group.orders.order_of_deduction
                var deductedOrders = group.orders.deducted
                var pedagogicalLoad = group.orders.on_pedagogical_load
                var groupCertification = group.certification

                let enrollment = {
                    Number: enrollmentOrder.number,
                    Date: this.$root.FormatDate(enrollmentOrder.date),
                    Listeners: enrollmentOrder.listeners,
                    Workers: enrollmentOrder.workers,
                    Students: enrollmentOrder.students
                }

                enrollment.Listeners.sort((a,b) => this.UserByID(a) !== null && this.UserByID(b) !== null ? this.UserByID(a).FIO > this.UserByID(b).FIO ? 1 : this.UserByID(a).FIO < this.UserByID(b).FIO ? -1 : 0 : 0)
                enrollment.Workers.sort((a,b) => this.UserByID(a) !== null && this.UserByID(b) !== null ? this.UserByID(a).FIO > this.UserByID(b).FIO ? 1 : this.UserByID(a).FIO < this.UserByID(b).FIO ? -1 : 0 : 0)
                enrollment.Students.sort((a,b) => this.UserByID(a) !== null && this.UserByID(b) !== null ? this.UserByID(a).FIO > this.UserByID(b).FIO ? 1 : this.UserByID(a).FIO < this.UserByID(b).FIO ? -1 : 0 : 0)

                let deduction = {
                    Number: deductionOrder.number,
                    Date: this.$root.FormatDate(deductionOrder.date),
                    Listeners: deductionOrder.listeners,
                    Workers: deductionOrder.workers,
                    Students: deductionOrder.students,
                    Document: deductionOrder.type_document
                }

                deduction.Listeners.sort((a,b) => this.UserByID(a) !== null && this.UserByID(b) !== null ? this.UserByID(a).FIO > this.UserByID(b).FIO ? 1 : this.UserByID(a).FIO < this.UserByID(b).FIO ? -1 : 0 : 0)
                deduction.Workers.sort((a,b) => this.UserByID(a) !== null && this.UserByID(b) !== null ? this.UserByID(a).FIO > this.UserByID(b).FIO ? 1 : this.UserByID(a).FIO < this.UserByID(b).FIO ? -1 : 0 : 0)
                deduction.Students.sort((a,b) => this.UserByID(a) !== null && this.UserByID(b) !== null ? this.UserByID(a).FIO > this.UserByID(b).FIO ? 1 : this.UserByID(a).FIO < this.UserByID(b).FIO ? -1 : 0 : 0)

                let pedLoad = {
                    Number: pedagogicalLoad.number,
                    Date: this.$root.FormatDate(pedagogicalLoad.date),
                    TotalHourNumber: 0,
                    Loads: []
                }

                var totalHourNumber = 0

                for (var j in pedagogicalLoad.pedagogical_loads) {
                    var load = pedagogicalLoad.pedagogical_loads[j]

                    pedLoad.Loads.push({
                        WorkerID: load.id_worker,
                        HourNumber: load.number_of_hours,
                        Discipline: load.education_discipline
                    })

                    totalHourNumber += load.number_of_hours
                }

                pedLoad.TotalHourNumber = totalHourNumber

                let members = []

                for (var j in groupCertification.members_of_the_attestation_commission) {
                    var member = groupCertification.members_of_the_attestation_commission[j]
                    members.push({
                        FIO: `${member.surname} ${member.name} ${member.middle_name}`,
                        Surname: member.surname,
                        Name: member.name,
                        Lastname: member.middle_name,
                        Post: member.post
                    })
                }

                let certification = {
                    Number: groupCertification.number,
                    FinalWorkType: groupCertification.type_of_final_work,
                    FinalCertificationForm: groupCertification.form_of_final_certification,
                    Date: this.$root.FormatDate(groupCertification.date),
                    ComissionChairman: {
                        FIO: `${groupCertification.chairman_of_commission.surname} ${groupCertification.chairman_of_commission.name} ${groupCertification.chairman_of_commission.middle_name}`,
                        Surname: groupCertification.chairman_of_commission.surname,
                        Name: groupCertification.chairman_of_commission.name,
                        Lastname: groupCertification.chairman_of_commission.middle_name,
                        Post: groupCertification.chairman_of_commission.post
                    },
                    Members: members
                }

                let deducted = []

                for (var j in deductedOrders) {
                    var order = deductedOrders[j]

                    deducted.push({
                        ID: order.id,
                        UserID: order.user_id,
                        Number: order.number,
                        Date: this.$root.FormatDate(order.date)
                    })
                }

                groups.push({
                    ID: group.id,
                    ProgramID: group.program_id,
                    IsClosed: group.is_closed,
                    IsCombined: group.is_combined,
                    CombinedGroups: group.combined_study_groups,
                    Title: group.title,
                    Location: group.location,
                    BeginDate: this.$root.FormatDate(group.start_date),
                    EndDate: this.$root.FormatDate(group.end_date),
                    Price: group.price,
                    FinancingType: group.type_of_financing,
                    Enrollment: enrollment,
                    Deduction: deduction,
                    Deducted: deducted,
                    PedagogicalLoad: pedLoad,
                    Certification: certification
                })
            }

            this.groups = groups

            this.$root.EndLoading()
        },
        SetCurrentGroup(index, selector) {
            this.currentGroup = this.groups[index]

            this.currentGroupUsers = []

            this.currentGroupUsers = [].concat(this.currentGroup.Enrollment.Listeners, this.currentGroup.Enrollment.Workers, this.currentGroup.Enrollment.Students)

            this.download_contract_users = []

            this.contract_buffer.dodop.can_be_confirmed = false
            this.contract_buffer.dodop.date = null

            if (selector !== undefined && selector !== null) {
                this.$root.ShowModal(selector)
            }
        },
        UpdateCurrentGroup(index) {
            this.currentGroup = this.groups[index]

            this.currentGroupUsers = []

            this.currentGroupUsers = [].concat(this.currentGroup.Enrollment.Listeners, this.currentGroup.Enrollment.Workers, this.currentGroup.Enrollment.Students)
        },
        ProgramByID(id) {
            let program = null

            for (var i in this.programs) {
                var p = this.programs[i]
                if (p.ID == id) {
                    program = p
                    break
                }
            }

            return program
        },
        UserByID(id) {
            let user = null

            user = this.users[id] || null

            return user
        },
        NewGroup(e) {
            e.preventDefault()

            let is_combined = this.$refs.group_combined.checked
            let combined_groups = this.$refs.group_combined_groups.value
            let title = this.$refs.group_title.value
            let program = this.$refs.group_program.value
            let location = this.$refs.group_location.value
            let beginDate = this.$refs.group_begin_date.value + "T00:00:00Z"
            let endDate = this.$refs.group_end_date.value + "T00:00:00Z"
            let financingType = this.$refs.group_financing_type.value
            let price = Number(this.$refs.group_price.value)

            beginDate = beginDate == "T00:00:00Z" ? undefined : beginDate
            endDate = endDate == "T00:00:00Z" ? undefined : endDate

            let enrollmentNumber = this.$refs.group_enrollment_number.value
            let enrollmentDate = this.$refs.group_enrollment_date.value + "T00:00:00Z"
            let loadNumber = this.$refs.pedagogical_load_number.value
            let loadDate = this.$refs.pedagogical_load_date.value + "T00:00:00Z"

            enrollmentDate = enrollmentDate == "T00:00:00Z" ? "" : enrollmentDate

            loadDate = loadDate == "T00:00:00Z" ? "" : loadDate

            let listeners = []
            let workers = []
            let students = []

            for (var i in this.selected_users) {
                var user = this.UserByID(this.selected_users[i])
                if (user.Role == "worker") {
                    workers.push(user.ID)
                }
                if (user.Role == "listener") {
                    listeners.push(user.ID)
                }
                if (user.Role == "student") {
                    students.push(user.ID)
                }
            }

            let loads = []

            for (var i in this.pedLoad) {
                var load = this.pedLoad[i]
                loads.push({
                    id_worker: load.Worker,
                    number_of_hours: load.HourNumber,
                    education_discipline: load.Discipline
                })
            }

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/", {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    is_combined: is_combined,
                    combined_study_groups: combined_groups,
                    title: title,
                    program_id: program,
                    location: location,
                    start_date: beginDate,
                    end_date: endDate,
                    type_of_financing: financingType,
                    price: Number(price),
                    orders: {
                        order_of_enrollment: {
                            number: enrollmentNumber,
                            date: enrollmentDate,
                            listeners: listeners,
                            workers: workers,
                            students: students
                        },
                        on_pedagogical_load: {
                            number: loadNumber,
                            date: loadDate,
                            pedagogical_loads: loads
                        }
                    }
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Группа успешно добавлена", "success")
                this._ProccessGroups()
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        DeleteGroup(id) {
            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/", {
                method: "DELETE",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({ id: id })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Группа успешно удалена", "success")
                this._ProccessGroups()
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        ChangeGroup(e) {
            e.preventDefault()

            let status = this.$refs.current_group_status.value

            if (!this.currentGroup.IsClosed && status !== "true") {
                let is_combined = this.$refs.current_group_combined.checked
                let combined_groups = this.$refs.current_group_combined_groups.value
                let title = this.$refs.current_group_title.value
                let location = this.$refs.current_group_location.value
                let beginDate = this.$refs.current_group_begin_date.value + "T00:00:00Z"
                let endDate = this.$refs.current_group_end_date.value + "T00:00:00Z"
                let financingType = this.$refs.current_group_financing_type.value
                let price = Number(this.$refs.current_group_price.value)

                fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/", {
                    method: "PUT",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                        'Content-Type': 'text/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        id: this.currentGroup.ID,
                        is_combined: is_combined,
                        combined_study_groups: combined_groups,
                        title: title,
                        location: location,
                        start_date: beginDate,
                        end_date: endDate,
                        type_of_financing: financingType,
                        price: Number(price),
                    })
                })
                .then(response => response.json())
                .then(res => {
                    if (this.$root.HandleFetchError(res)) return
                    this.$root.ShowToast("Данные группы успешно изменены", "success")
                    this._ProccessGroups()
                })
                .catch(error => {
                    this.$root.Fatal()
                })
            }

            if (status === "true" && !this.currentGroup.IsClosed) {
                fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/close", {
                    method: "PUT",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                        'Content-Type': 'text/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        id: this.currentGroup.ID
                    })
                })
                .then(response => response.json())
                .then(res => {
                    if (this.$root.HandleFetchError(res)) return
                    this.$root.ShowToast("Группа успешно закрыта", "success")
                    this._ProccessGroups()
                })
                .catch(error => {
                    this.$root.Fatal()
                })
            } else if (status === "false" && this.currentGroup.IsClosed) {
                fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/open", {
                    method: "PUT",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                        'Content-Type': 'text/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        id: this.currentGroup.ID
                    })
                })
                .then(response => response.json())
                .then(res => {
                    if (this.$root.HandleFetchError(res)) return
                    this.$root.ShowToast("Группа успешно открыта", "success")
                    this._ProccessGroups()
                })
                .catch(error => {
                    this.$root.Fatal()
                })
            }
        },
        ChangeEnrollment(e) {
            e.preventDefault()

            let number = this.$refs.current_group_enrollment_number.value
            let date = this.$refs.current_group_enrollment_date.value + "T00:00:00Z"

            date = date == "T00:00:00Z" ? undefined : date

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/orders", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    order_of_enrollment: {
                        number: number,
                        date: date
                    },
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Данные приказа о зачислении успешно изменены", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        ChangeDeduction(e) {
            e.preventDefault()

            let number = this.$refs.current_group_deduction_number.value
            let date = this.$refs.current_group_deduction_date.value + "T00:00:00Z"

            date = date == "T00:00:00Z" ? undefined : date

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/orders", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    order_of_deduction: {
                        number: number,
                        date: date
                    },
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Данные приказа о выпуске успешно изменены", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        ChangeCertification(e) {
            e.preventDefault()
            
            let number = this.$refs.current_group_certification_number.value
            let date = this.$refs.current_group_certification_date.value + "T00:00:00Z"
            let workType = this.$refs.current_group_certification_work_type.value
            let certificationType = this.$refs.current_group_certification_certification_type.value

            date = date == "T00:00:00Z" ? undefined : date

            let surname = this.$refs.current_group_certification_chairman_surname.value
            let name = this.$refs.current_group_certification_chairman_name.value
            let lastname = this.$refs.current_group_certification_chairman_lastname.value
            let post = this.$refs.current_group_certification_chairman_post.value

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/certification", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    number: number,
                    date: date,
                    form_of_final_certification: certificationType,
                    type_of_final_work: workType,
                    chairman_of_commission: {
                        surname: surname,
                        name: name,
                        middle_name: lastname,
                        post: post
                    }
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Основные данные аттестации успешно изменены", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        AddCertificationMember(e) {
            e.preventDefault()

            let surname = this.$refs.current_group_certification_member_surname.value
            let name = this.$refs.current_group_certification_member_name.value
            let lastname = this.$refs.current_group_certification_member_lastname.value
            let post = this.$refs.current_group_certification_member_post.value

            e.target.reset()

            let members = []

            for (var i in this.currentGroup.Certification.Members) {
                var member =  this.currentGroup.Certification.Members[i]

                members.push({
                    surname: member.Surname,
                    name: member.Name,
                    middle_name: member.Lastname,
                    post: member.Post
                })
            }

            members.push({
                surname: surname,
                name: name,
                middle_name: lastname,
                post: post
            })

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/certification", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    members_of_the_attestation_commission: members
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Новый член аттестационной комиссии успешно добавлен", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        }, 
        DeleteCertificationMember(index) {

            let members = []

            for (var i in this.currentGroup.Certification.Members) {

                if (i == index) {
                    continue
                }

                var member =  this.currentGroup.Certification.Members[i]

                members.push({
                    surname: member.Surname,
                    name: member.Name,
                    middle_name: member.Lastname,
                    post: member.Post
                })
            }

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/certification", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    members_of_the_attestation_commission: members
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Член аттестационной комиссии успешно удалён", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        SetCurrentMember(index, selector) {
            this.currentMember = this.currentGroup.Certification.Members[index]

            if (selector !== undefined && selector !== null) {
                this.$root.ShowModal(selector)
            }
        },
        ChangeMember(e) {
            e.preventDefault()

            let surname = this.$refs.current_group_certification_current_member_surname.value
            let name = this.$refs.current_group_certification_current_member_name.value
            let lastname = this.$refs.current_group_certification_current_member_lastname.value
            let post = this.$refs.current_group_certification_current_member_post.value

            let index = this.currentGroup.Certification.Members.indexOf(this.currentMember)

            let members = []

            for (var i in this.currentGroup.Certification.Members) {

                if (i == index) {
                    members.push({
                        surname: surname,
                        name: name,
                        middle_name: lastname,
                        post: post
                    })
                    continue
                }

                var member =  this.currentGroup.Certification.Members[i]

                members.push({
                    surname: member.Surname,
                    name: member.Name,
                    middle_name: member.Lastname,
                    post: member.Post
                })
            }

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/certification", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    members_of_the_attestation_commission: members
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Данные члена аттестационной комиссии успешно изменены", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },  
        NewLoad(e) {
            e.preventDefault()

            let worker = this.$refs.load_worker.value
            let discipline = this.$refs.load_discipline.value
            let hour_number = Number(this.$refs.load_hour_number.value)

            e.target.reset()
            
            this.pedLoad.push({
                Worker: worker,
                Discipline: discipline,
                HourNumber: hour_number
            })
        },
        RemoveLoad(index) {
            this.pedLoad.splice(index, 1)
        },
        SelectUser(id) {
            this.selected_users.push(id)
        },
        RemoveUser(index) {
            this.selected_users.splice(index,1)
        },
        SelectCurrentGroupUser(id) {
            let users = JSON.parse(JSON.stringify(this.currentGroupUsers))
            users.push(id)

            let listeners = []
            let workers = []
            let students = []

            for (var i in users) {
                var user = this.UserByID(users[i])
                if (user.Role == "worker") {
                    workers.push(user.ID)
                }
                if (user.Role == "student") {
                    students.push(user.ID)
                }
                if (user.Role == "listener") {
                    listeners.push(user.ID)
                }
            }

            listeners.sort((a,b) => this.UserByID(a) !== null && this.UserByID(b) !== null ? this.UserByID(a).FIO > this.UserByID(b).FIO ? 1 : this.UserByID(a).FIO < this.UserByID(b).FIO ? -1 : 0 : 0)
            workers.sort((a,b) => this.UserByID(a) !== null && this.UserByID(b) !== null ? this.UserByID(a).FIO > this.UserByID(b).FIO ? 1 : this.UserByID(a).FIO < this.UserByID(b).FIO ? -1 : 0 : 0)
            students.sort((a,b) => this.UserByID(a) !== null && this.UserByID(b) !== null ? this.UserByID(a).FIO > this.UserByID(b).FIO ? 1 : this.UserByID(a).FIO < this.UserByID(b).FIO ? -1 : 0 : 0)

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/orders", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    order_of_enrollment: {
                        listeners: listeners,
                        workers: workers,
                        students: students,
                    },
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Список участников группы успешно изменён", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        RemoveCurrentGroupUser(index) {
            let users = JSON.parse(JSON.stringify(this.currentGroupUsers))

            users.splice(index,1)

            let listeners = []
            let workers = []
            let students = []

            for (var i in users) {
                var user = this.UserByID(users[i])
                if (user.Role == "worker") {
                    workers.push(user.ID)
                }
                if (user.Role == "student") {
                    students.push(user.ID)
                }
                if (user.Role == "listener") {
                    listeners.push(user.ID)
                }
            }

            listeners.sort((a,b) => this.UserByID(a) !== null && this.UserByID(b) !== null ? this.UserByID(a).FIO > this.UserByID(b).FIO ? 1 : this.UserByID(a).FIO < this.UserByID(b).FIO ? -1 : 0 : 0)
            workers.sort((a,b) => this.UserByID(a) !== null && this.UserByID(b) !== null ? this.UserByID(a).FIO > this.UserByID(b).FIO ? 1 : this.UserByID(a).FIO < this.UserByID(b).FIO ? -1 : 0 : 0)
            students.sort((a,b) => this.UserByID(a) !== null && this.UserByID(b) !== null ? this.UserByID(a).FIO > this.UserByID(b).FIO ? 1 : this.UserByID(a).FIO < this.UserByID(b).FIO ? -1 : 0 : 0)
            
            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/orders", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    order_of_enrollment: {
                        listeners: listeners,
                        workers: workers,
                        students: students
                    },
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Список участников группы успешно изменён", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        ChangePedLoad(e) {
            e.preventDefault()

            let number = this.$refs.current_group_ped_load_number.value
            let date = this.$refs.current_group_ped_load_date.value + "T00:00:00Z"

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/orders", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    on_pedagogical_load: {
                        number: number,
                        date: date
                    },
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Данные приказа о пед. нагрузке успешно изменены", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        NewCurrentGroupLoad(e) {
            e.preventDefault()

            let worker = this.$refs.current_group_load_worker.value
            let discipline = this.$refs.current_group_load_discipline.value
            let hour_number = Number(this.$refs.current_group_load_hour_number.value)

            e.target.reset()

            let loads = []

            for (var i in this.currentGroup.PedagogicalLoad.Loads) {
                var load = this.currentGroup.PedagogicalLoad.Loads[i]

                loads.push({
                    id_worker: load.WorkerID,
                    education_discipline: load.Discipline,
                    number_of_hours: load.HourNumber
                })
            }

            loads.push({
                id_worker: worker,
                education_discipline: discipline,
                number_of_hours: hour_number
            })

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/orders", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    on_pedagogical_load: {
                        pedagogical_loads: loads,
                    },
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Новая пед. нагрузка успешно добавлена", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        DeleteCurrentGroupLoad(index) {
            let loads = []

            for (var i in this.currentGroup.PedagogicalLoad.Loads) {

                if (i == index) {
                    continue
                }

                var load = this.currentGroup.PedagogicalLoad.Loads[i]

                loads.push({
                    id_worker: load.WorkerID,
                    education_discipline: load.Discipline,
                    number_of_hours: load.HourNumber
                })
            }

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/orders", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    on_pedagogical_load: {
                        pedagogical_loads: loads,
                    },
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Пед. нагрузка успешно удалена", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        SetCurrentLoad(index, selector) {
            this.currentLoad = this.currentGroup.PedagogicalLoad.Loads[index]

            if (selector !== undefined && selector !== null) {
                this.$root.ShowModal(selector)
            }
        },
        ChangeCurrentGroupLoad(e) {
            e.preventDefault()

            let worker = this.$refs.current_group_current_load_worker.value
            let discipline = this.$refs.current_group_current_load_discipline.value
            let hour_number = Number(this.$refs.current_group_current_load_hour_number.value)

            let index = this.currentGroup.PedagogicalLoad.Loads.indexOf(this.currentLoad)

            let loads = []

            for (var i in this.currentGroup.PedagogicalLoad.Loads) {

                if (i == index) {
                    loads.push({
                        id_worker: worker,
                        education_discipline: discipline,
                        number_of_hours: hour_number
                    })
                    continue
                }

                var load = this.currentGroup.PedagogicalLoad.Loads[i]

                loads.push({
                    id_worker: load.WorkerID,
                    education_discipline: load.Discipline,
                    number_of_hours: load.HourNumber
                })
            }

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/orders", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    on_pedagogical_load: {
                        pedagogical_loads: loads,
                    },
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Данные пед. нагрузки успешно изменены", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        NewDeducted(e) {
            e.preventDefault()

            let number = this.$refs.current_group_deducted_number.value
            let date = this.$refs.current_group_deducted_date.value + "T00:00:00Z"
            let user = this.$refs.current_group_deducted_user.value

            let orders = []

            for (var i in this.currentGroup.Deducted) {
                var order = this.currentGroup.Deducted[i]

                orders.push({
                    id: order.ID,
                    user_id: order.UserID,
                    number: order.Number,
                    date: this.$root.FormatInputDate(order.Date) + "T00:00:00Z"
                })
            }

            orders.push({
                user_id: user,
                number: number,
                date: date
            })

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/orders", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    deducted: orders
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Приказ об отчислении успешно добавлен", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        DeleteDeducted(index) {
            let orders = []

            for (var i in this.currentGroup.Deducted) {

                if (i == index) {
                    continue
                }

                var order = this.currentGroup.Deducted[i]

                orders.push({
                    id: order.ID,
                    user_id: order.UserID,
                    number: order.Number,
                    date: this.$root.FormatInputDate(order.Date) + "T00:00:00Z"
                })
            }

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/orders", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    deducted: orders
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Приказ об отчислении успешно удалён", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        ChangeDeducted(e) {
            e.preventDefault()

            let number = this.$refs.current_group_current_deducted_number.value
            let date = this.$refs.current_group_current_deducted_date.value + "T00:00:00Z"
            let user = this.$refs.current_group_current_deducted_user.value

            date = date == "T00:00:00Z" ? undefined : date

            let index = this.currentGroup.Deducted.indexOf(this.currentDeducted)

            let orders = []

            for (var i in this.currentGroup.Deducted) {

                var order = this.currentGroup.Deducted[i]

                if (i == index) {
                    orders.push({
                        id: order.ID,
                        user_id: user,
                        number: number,
                        date: date
                    })
                    continue
                }

                orders.push({
                    id: order.ID,
                    user_id: order.UserID,
                    number: order.Number,
                    date: this.$root.FormatInputDate(order.Date) + "T00:00:00Z"
                })
            }

            

            fetch(this.$store.state.aeApiAddr + "/v1.0/study_groups/orders", {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                    'Content-Type': 'text/json;charset=utf-8'
                },
                body: JSON.stringify({
                    id: this.currentGroup.ID,
                    deducted: orders
                })
            })
            .then(response => response.json())
            .then(res => {
                if (this.$root.HandleFetchError(res)) return
                this.$root.ShowToast("Приказ об отчислении успешно изменён", "success")
                let index = this.groups.indexOf(this.currentGroup)
                this._ProccessGroups().then(()=>{this.UpdateCurrentGroup(index)})
            })
            .catch(error => {
                this.$root.Fatal()
            })
        },
        SetCurrentDeducted(index, selector) {
            this.currentDeducted = this.currentGroup.Deducted[index]

            if (selector !== undefined && selector !== null) {
                this.$root.ShowModal(selector)
            }
        },
        FilterUsers(e) {
            let filter = e.target.value.trim()

            if (filter == "") {
                this.filtered_users = this.users
                return
            }
            this.filtered_users = Object.keys(this.users)
                                    .filter((key)=>{return this.users[key].FIO.toLowerCase().includes(filter.toLowerCase())})
                                    .reduce((res, key) => (res[key] = this.users[key], res), {})
        },
        SeeGroup(id) {
            this.$store.commit('setJournalID', id)
            this.$store.commit('updateJournalID')
            this.$router.push({name: 'GroupJournal'})
        },
        CreateGroupUsersOptions(data) {
            let res = []

            for (var i in data) {
                var user = data[i]

                res.push({value: user, label: this.UserByID(user).FIO})
            }

            res.sort((a,b) => a.label !== null && b.label !== null ? a.label > b.label ? 1 : a.label < b.label ? -1 : 0 : 0)

            return res
        },
        async DownloadDodop() {
            let date = this.contract_buffer.dodop.date

            let is_single = this.download_contract_users.length == 1

            let data = {}

            if (date == null || date == "") {
                this.$root.ShowToast("Дата документа обязательный параметр", "error")
                return
            }

            if (is_single)
                data["user_id"] = this.download_contract_users[0]
            else
                data["users"] = this.download_contract_users

            data["program_id"] = this.currentGroup.ProgramID

            data["date"] = this.contract_buffer.dodop.date + "T00:00:00Z"

            if (!is_single) {
                let cont = confirm("При скачивании договоров, они будут автоматически подтверждены! Продолжить")
                if (!cont) return
            }

            try {
                var res = await fetch(this.$store.state.filesApiAddr + `/v1.0/ae/contracts/education_additional_general_development_program${!is_single ? "s" : ""}`, {
                    method: "POST",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                        'Content-Type': 'text/json;charset=utf-8'
                    },
                    body: JSON.stringify(data)
                })
                .catch(error=> {
                    this.$root.ShowToast("Не удалось скачать договоры", "error")
                })

                var result = await res.blob()

                var name = res.headers.get('Content-Disposition').split('filename=')[1].split('"')[1].replace("do-b", "до-б")

                var a = document.createElement("a")
                a.setAttribute("href", URL.createObjectURL(result))
                a.setAttribute("target", "_blank")
                a.setAttribute("download", is_single ? name : "договоры.zip")
                document.body.appendChild(a)
                a.click()
                URL.revokeObjectURL(a.href)
                a.remove()
                this.contract_buffer.dodop.can_be_confirmed = is_single ? true : false
                this.contract_buffer.dodop.name = is_single ? name.replace("-", "/").replace(".docx", "").replace(".zip", "") : null
                if (!is_single)
                    this.$root.ShowToast("Договоры подтверждены", "success")
            } catch (e) {
                this.$root.ShowToast("Не удалось скачать договоры", "error")
            }
        },
        ConfirmDodop() {
            fetch(this.$store.state.aeApiAddr + "/v1.0/journal_contracts/confirm", {
                    method: "POST",
                    headers: {
                        'Authorization': `Bearer ${this.$root.GetToken()}`,
                        'Content-Type': 'text/json;charset=utf-8'
                    },
                    body: JSON.stringify({
                        user_id: this.download_contract_users[0],
                        program_id: this.currentGroup.ProgramID,
                        date: this.contract_buffer.dodop.date + "T00:00:00Z",
                        contract_number: this.contract_buffer.dodop.name
                    })
                })
                .then(response => response.json())
                .then(res => {
                    if (this.$root.HandleFetchError(res)) return
                    this.$root.ShowToast("Договоры подтверждены", "success")
                })
                .catch(error=> {
                    this.$root.ShowToast("Не удалось подтвердить договоры", "error")
                })
        }
    },
    mounted() {
        if (this.$root.fatal) return
        this.SetTitle()
        this.$root.StartLoading()
        this.$root.UpdateToken()
        this.$root.GetRoles().then(()=> {
            if (!(this.$root.HasRole(this.$store.state.employeeRole) || this.$root.HasRole(this.$store.state.adminRole) || this.$root.HasRole(this.$store.state.methodistRole))) {
                this.$root.ShowToast("У вас нет прав на посещение данного раздела", "error", 8000)
                this.$router.push({name: 'Home'})
                return
            }

            this.onlyMyGroups = this.$root.HasRole(this.$store.state.employeeRole)

            this._ProccessUsers().then(()=>{
                this.$root.StartLoading()
                this._ProccessGroups().then(()=>{
                    this.$root.EndLoading()
                })
            })
            this._ProccessPrograms()
            this._SelectData()
        }) 
    }
}
</script>